import React,{useEffect} from 'react'
import { useParams , useNavigate } from 'react-router';


import axios from 'axios';
import { CircularProgress } from '@mui/material';

axios.defaults.baseURL = "https://auth-k.gtoken.in/";

function PortalLandingPage() {

    let { portalId } = useParams();
    const navigate = useNavigate();
    const setPortal = (portalId) =>{
        axios.post("/portal/verify",{portalId:portalId}).then(res=>{
            if(res.data.error){
                console.log("No Portal found")
            } else {
                localStorage.setItem("portalId",portalId);
                localStorage.setItem("portalUrl",res.data.data.url);
                localStorage.setItem("portalTitle",res.data.data.title);
                localStorage.setItem("notificationUrl",res.data.data.notificationUrl);
                window.location.reload();
            }
        }).catch(error=>{
            
        })
    }

    const getPortal =() =>{
        console.log(portalId )
        if(portalId != localStorage.portalId){
            setPortal(portalId);
        } else {
            if(localStorage.portalUrl != undefined) {
                console.log("ready");
                navigate("/")
            }
        }
    }
    useEffect(()=>{
        getPortal()
    },[])
    
    return (
        <div className="container">
            <div className="row mt-5">
                <div className='col-md-12 text-center'>
                    <img src='/images/gtoken-logo.jpg' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center">
                    <CircularProgress/>
                </div>
            </div>
        </div>
    )
}

export default PortalLandingPage